import ErrorWrapper from "../components/ErrorPage/ErrorWrapper/ErrorWrapper";

const ErrorPage = () => {
  return <ErrorWrapper />;
};

export default ErrorPage;
